// extracted by mini-css-extract-plugin
module.exports = {"block":"styles_block__BchqT","label":"styles_label__3AFDk","naTag":"styles_naTag__2kfWd"};